import {Component, Input} from '@angular/core';
import {UserResponse} from '../../../../@shared/models/response.module';

@Component({
  selector: 'app-user-profile-header',
  standalone: false,
  templateUrl: './user-profile-header.html',
  styleUrl: './user-profile-header.css'
})
export class UserProfileHeader {
  @Input() user: UserResponse
}
